import React from 'react'

function OurCoreValues() {
   return (
      <section className="cs-bg-secondary pt-0">
         <div className="container">
            <h2 className="section_heading_title mb-3 tech_title">
               Our Core Values
            </h2>

            <p className="section_desc mb-md-5 mb-3 core-value-sub">
               We don't simply code—we live by a code of conduct that keeps us
               on our toes, honest, and merciless. <br />
               These aren't buzzwords; they're the pulse of every app we create
               and every bug we kill.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main core_values_main">
               <div className="row g-4 industry-grid">
                  <div className="col-lg-3 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="big-nos">01</div>
                        <h3 className="industry-subtitle">
                           Relentless Problem-Solving
                        </h3>
                        <p className="industry-description">
                           We don’t stop until it works. Period. A server’s down
                           at 2 a.m.? We’re on it. A client’s dream app hits a
                           wall? We’ll tear it down and rebuild it better. Since
                           2013, we’ve been the crew that thrives on the
                           impossible, turning chaos into solutions that stick.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-3 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="big-nos">02</div>
                        <h3 className="industry-subtitle">
                           Fearless Innovation
                        </h3>
                        <p className="industry-description">
                           We don’t follow trends—we set them. Stale ideas get
                           the boot; bold ones get a green light. Whether it’s a
                           bleeding-edge framework or a hack no one’s tried,
                           we’re always pushing the edge of what’s possible,
                           because playing it safe never changed the game.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-3 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="big-nos">03</div>
                        <h3 className="industry-subtitle">All-In Teamwork</h3>
                        <p className="industry-description">
                           We’re a pack, not a hierarchy. Every coder, every
                           designer, every dreamer in our team goes all-in
                           because the greatest apps aren't written
                           alone—they're hammered out over late-night sessions
                           and "what if" wars. Together, we're indestructible.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-3 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="big-nos">04</div>
                        <h3 className="industry-subtitle">
                           User-First Obsession
                        </h3>
                        <p className="industry-description">
                           We don’t build for ourselves—we build for the people
                           who’ll use it. Every feature, every line of code, is
                           a question: “Does this make their life easier?” If
                           the answer’s no, it’s out. Your users deserve tech
                           that fights for them, and we deliver.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-3 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="big-nos">05</div>
                        <h3 className="industry-subtitle">Brutal Honesty</h3>
                        <p className="industry-description">
                           No sugarcoating here. If your idea’s got holes, we’ll
                           tell you—and then help you fix it. We share the wins,
                           the fails, and the messy middle, because trust is the
                           only way to build tech that lasts. You’ll always know
                           where we stand.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-3 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="big-nos">06</div>
                        <h3 className="industry-subtitle">
                           Speed with Precision
                        </h3>
                        <p className="industry-description">
                           We move fast, but we don’t half-ass it. Deadlines
                           don’t scare us—they fuel us. We ship on time, every
                           time, without sacrificing the details that make your
                           app a beast. It’s the 2013 hustle, refined over a
                           decade of sprints.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-3 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="big-nos">07</div>
                        <h3 className="industry-subtitle">Own the Mess</h3>
                        <p className="industry-description">
                           If we break it, we fix it—no excuses. We take
                           accountability for every glitch, every delay, every
                           “oh crap” moment. It’s how we’ve earned trust since
                           day one, and why clients stick with us through the
                           wild ride of tech.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-3 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="big-nos">08</div>
                        <h3 className="industry-subtitle">Keep It Human</h3>
                        <p className="industry-description">
                           Tech’s cold, but we’re not. We laugh, we curse, we
                           care—about our craft, our clients, and each other.
                           We’re the team that’ll celebrate your launch like
                           it’s our own, because building something epic is
                           personal to us.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default OurCoreValues
